import { Component } from "@angular/core";

@Component({
	selector: 'app-login-loading',
	templateUrl: './loading.component.html',
	styleUrls: ['./loading.component.scss'],
})
export class LoginLoadingComponent  {
}